import React from 'react';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

import { SecondaryButton } from '../button/Button.jsx';
import { releaseHold, useAccessHold } from '../../authentication/accessHold.js';
import { hasUnsavedWork } from '../../utils/unsavedWork.js';
import './AccessHoldBanner.css';

/**
 * Shown on a page the user lost access to while it was open (accessHold.js). The page stays - what they typed is
 * still there - until they choose to leave. "Leave now" ends the hold: the guards then do what they would have done,
 * replacing the page with its access card or taking the user to a page they can open.
 */
const AccessHoldBanner = () => {
    const location = useLocation();
    const { denial } = useAccessHold(location.pathname);
    if (!denial) return null;
    const unsaved = hasUnsavedWork();
    return (
        <div className="access-hold-banner" role="alert">
            <FontAwesomeIcon icon={faTriangleExclamation} className="access-hold-banner-icon" />
            <div className="access-hold-banner-text">
                <strong>{denial.message}</strong>
                <span>
                    {unsaved
                        ? ' Your unsaved changes are still on this page - copy anything you need first. Saving is no longer possible, and leaving discards them.'
                        : ' You can stay on this page until you leave it.'}
                </span>
            </div>
            <SecondaryButton size="small" onClick={releaseHold}>Leave Now</SecondaryButton>
        </div>
    );
};

export default AccessHoldBanner;
